// extracted by mini-css-extract-plugin
module.exports = {"container":"UnionDuesContributionSection__container--1AUSE"};